import { render } from "./ModalDeleteCheck.vue?vue&type=template&id=27c48e1f&ts=true"
import script from "./ModalDeleteCheck.vue?vue&type=script&lang=ts"
export * from "./ModalDeleteCheck.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__